<template>
  <div id="alterations">
    <div class="header flex-between">
      <div class="header-text">
        <h1>用户管理</h1>
      </div>
      <div class="header-button">
        <el-button
          v-if="jurisdiction.search"
          icon="iconfont icon-sousuo1"
          @click="searchYhSy"
          >查询</el-button
        >
        <el-button
          v-if="jurisdiction.create"
          icon="iconfont icon-chuangjian1"
          @click="createYhtc"
          >创建</el-button
        >
        <el-button
          v-if="jurisdiction.modify"
          icon="iconfont icon-xiugai1"
          @click="modifyYhtc"
          >修改</el-button
        >
        <el-button
          v-if="jurisdiction.enable"
          icon="iconfont icon-chuangjian1"
          @click="Enabledisable"
          >启用/禁用</el-button
        >
        <el-button
          v-if="jurisdiction.look"
          icon="iconfont icon-chakan1"
          @click="LookYhlb"
          >查看</el-button
        >
        <el-button
          v-if="jurisdiction.userdefined"
          icon="iconfont icon-chakan1"
          @click="roledefinition"
          >用户角色定义</el-button
        >
      </div>
    </div>
    <!-- 创建弹窗 -->
    <div class="found">
      <el-dialog
        width="28%"
        title="用户管理-创建"
        :visible.sync="foundFormVisible"
        :close-on-click-modal="false"
        @close="CreatedYhClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="createFormyh"
            :rules="createyhrules"
            ref="createFormyhRef"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工编号" prop="empCode">
                  <el-input
                    v-model="createFormyh.empCode"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名" prop="empName">
                  <el-input v-model="createFormyh.empName" style="width: 70%">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input
                    v-model="createFormyh.mobile"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="企业微信ID" prop="weChatUserID">
                  <el-input
                    v-model="createFormyh.weChatUserID"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="门店" prop="orgCode">
                  <el-autocomplete
                    style="width: 70%"
                    v-model="createFormyh.orgCode"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入门店编号"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="门店名称" prop="shopname">
                  <el-input
                    disabled
                    v-model="createFormyh.shopname"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工类型" prop="empKind">
                  <el-select
                    style="width: 70%"
                    v-model="createFormyh.empKind"
                    @change="createdempKind"
                  >
                    <el-option label="门店员工" value="1"></el-option>
                    <el-option label="区域员工" value="2"></el-option>
                    <el-option label="公司员工" value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="员工岗位"
                  prop="empPosition"
                  v-if="createFormyh.empKind == 1"
                >
                  <el-radio-group
                    id="radiof"
                    style="width: 70%"
                    @change="createEmpPositionChanged"
                    v-model="createFormyh.empPosition"
                    :disabled="disabled"
                  >
                    <el-radio label="1">员工</el-radio>
                    <el-radio label="2">店长</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="店长类型"
                  prop="shoperKind"
                  v-if="
                    createFormyh.empKind == 1 && createFormyh.empPosition == 2
                  "
                >
                  <el-radio-group
                    id="radiof"
                    style="width: 70%"
                    v-model="createFormyh.shoperKind"
                  >
                    <el-radio :label="1">虚拟店长</el-radio>
                    <el-radio :label="0">实际店长</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="createYh('createFormyhRef')">保 存</el-button>
          <el-button @click="foundFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改弹窗 -->
    <div class="amend">
      <el-dialog
        width="28%"
        title="用户管理-修改"
        :visible.sync="amendFormVisible"
        :close-on-click-modal="false"
        @close="ModifyYhClosed"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="modifyYhList"
            :rules="createyhrules"
            ref="modifyFormRef"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工编号" prop="empCode">
                  <el-input
                    v-model="modifyYhList.empCode"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名" prop="empName">
                  <el-input v-model="modifyYhList.empName" style="width: 70%">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input
                    v-model="modifyYhList.mobile"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="企业微信ID" prop="weChatUserID">
                  <el-input
                    v-model="modifyYhList.weChatUserID"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="门店" prop="orgCode">
                  <el-autocomplete
                    style="width: 70%"
                    v-model="modifyYhList.orgCode"
                    :fetch-suggestions="querySearch"
                    placeholder="请输入门店编号"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="门店名称" prop="shopname">
                  <el-input
                    disabled
                    v-model="modifyYhList.shopname"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工类型" prop="empKind">
                  <el-select style="width: 70%" v-model="modifyYhList.empKind" @change="updatedempKind">
                    <el-option label="门店员工" :value="1"></el-option>
                    <el-option label="区域员工" :value="2"></el-option>
                    <el-option label="公司员工" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="员工岗位"
                  prop="empPosition"
                  v-if="modifyYhList.empKind == 1"
                >
                  <el-radio-group
                    id="radiof"
                    style="width: 70%"
                    @change="updateEmpPositionChanged"
                    v-model="modifyYhList.empPosition"
                    :disabled="disabled"
                  >
                    <el-radio :label="1">员工</el-radio>
                    <el-radio :label="2">店长</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  label="店长类型"
                  prop="shoperKind"
                  v-if="
                    modifyYhList.empKind == 1 && modifyYhList.empPosition == 2
                  "
                >
                  <el-radio-group
                    id="radiof"
                    style="width: 70%"
                    v-model="modifyYhList.shoperKind"
                  >
                    <el-radio :label="1">虚拟店长</el-radio>
                    <el-radio :label="0">实际店长</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="ModifyQdqq">保 存</el-button>
          <el-button @click="amendFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 启用禁用提示框 -->
    <div class="Enabledisable">
      <el-dialog
        width="20%"
        title="启用/禁用确认取消提示框"
        :visible.sync="EnabledisableFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">{{ qiyongjinyong }}</span
            >此用户?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="Enabledisableqd">确 定</el-button>
          <el-button @click="EnabledisableFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 查看弹窗 -->
    <div class="look">
      <el-dialog
        width="28%"
        title="用户管理-查看"
        :visible.sync="lookFormVisible"
        :close-on-click-modal="false"
        @close="SeeYhlbClose"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="lookFormLabelYh"
            ref="lookFormRef"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工编号" prop="empCode">
                  <el-input
                    disabled
                    v-model="lookFormLabelYh.empCode"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名" prop="empName">
                  <el-input
                    disabled
                    v-model="lookFormLabelYh.empName"
                    style="width: 70%"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="手机号码" prop="mobile">
                  <el-input
                    disabled
                    v-model="lookFormLabelYh.mobile"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="企业微信ID" prop="weChatUserID">
                  <el-input
                    disabled
                    v-model="lookFormLabelYh.weChatUserID"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="门店" prop="shopCode">
                  <el-input
                    disabled
                    v-model="lookFormLabelYh.shopCode"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="门店名称" prop="shopName">
                  <el-input
                    disabled
                    v-model="lookFormLabelYh.shopName"
                    style="width: 70%"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工类型" prop="empKind">
                  <el-select
                    disabled
                    style="width: 70%"
                    v-model="lookFormLabelYh.empKind"
                  >
                    <el-option label="门店员工" :value="1"></el-option>
                    <el-option label="区域员工" :value="2"></el-option>
                    <el-option label="公司员工" :value="3"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="24" v-if="lookFormLabelYh.empKind == 1">
                <el-form-item label="员工岗位" prop="empPosition">
                  <el-radio-group
                    style="width: 70%"
                    v-model="lookFormLabelYh.empPosition"
                    disabled
                  >
                    <el-radio :label="1">员工</el-radio>
                    <el-radio :label="2">店长</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col
                :span="24"
                v-if="
                  lookFormLabelYh.empKind == 1 &&
                  lookFormLabelYh.empPosition == 2
                "
              >
                <el-form-item label="店长类型" prop="shoperKind">
                  <el-radio-group
                    style="width: 70%"
                    v-model="lookFormLabelYh.shoperKind"
                    disabled
                  >
                    <el-radio :label="1">虚拟店长</el-radio>
                    <el-radio :label="0">实际店长</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
              <el-col :span="24">
                <el-form-item label="创建人" prop="createUserName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 70%"
                      v-model="lookFormLabelYh.createUserName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="创建时间" prop="createTime">
                  <el-date-picker
                    style="width: 70%"
                    :disabled="true"
                    v-model="lookFormLabelYh.createTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="最后修改人" prop="updateUserName">
                  <div class="flex-start">
                    <el-input
                      disabled
                      style="width: 70%"
                      v-model="lookFormLabelYh.updateUserName"
                    >
                    </el-input>
                  </div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="最后修改时间" prop="updateTime">
                  <el-date-picker
                    style="width: 70%"
                    :disabled="true"
                    v-model="lookFormLabelYh.updateTime"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="lookFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 用户角色定义弹窗 -->
    <div class="definition">
      <el-dialog
        width="30%"
        title="用户管理-用户角色定义"
        :visible.sync="definitionVisible"
        :close-on-click-modal="false"
        @close="RoledefinitionClose"
      >
        <div>
          <el-form
            size="mini"
            label-width="120px"
            :model="Roledefinition"
            ref="RoledefinitionRef"
            :rules="Rolederules"
          >
            <el-row>
              <el-col :span="24">
                <el-form-item label="员工编号" prop="empCode">
                  <el-input
                    disabled
                    style="width: 75%"
                    v-model="Roledefinition.empCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="姓名" prop="empName">
                  <el-input
                    disabled
                    style="width: 75%"
                    v-model="Roledefinition.empName"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="企业微信ID" prop="weChatUserID">
                  <el-input
                    disabled
                    style="width: 75%"
                    v-model="Roledefinition.weChatUserID"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="门店" prop="shopCode">
                  <el-input
                    disabled
                    style="width: 75%"
                    v-model="Roledefinition.shopCode"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="门店名称" prop="shopName">
                  <el-input
                    disabled
                    style="width: 75%"
                    v-model="Roledefinition.shopName"
                  >
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="数据权限" prop="dataRoleId">
                  <el-select
                    style="width: 75%"
                    v-model="Roledefinition.dataRoleId"
                  >
                    <el-option
                      v-for="item in DataauthorityList"
                      :key="item.id"
                      :label="item.roleName"
                      :value="item.roleID"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="操作权限">
                  <el-button @click="Selectrole">选择角色</el-button>
                  <el-table
                    style="width: 75%"
                    height="195px"
                    border
                    class="table-style"
                    :row-class-name="tableRowClassName"
                    :header-cell-style="{
                      background: '#FCFBF2',
                      'text-align': 'center',
                      color: '#6C6839',
                      fontSize: '14px',
                    }"
                    :cell-style="{ 'text-align': 'center' }"
                    :data="Operationauthority"
                  >
                    <el-table-column type="index" width="50"> </el-table-column>
                    <el-table-column prop="roleCode" label="角色编号">
                    </el-table-column>
                    <el-table-column prop="roleName" label="角色描述">
                    </el-table-column>
                    <el-table-column label="操作">
                      <template slot-scope="scope">
                        <el-button
                          class="shanchuanniu"
                          @click.native.prevent="
                            deleteRow(scope.$index, Operationauthority)
                          "
                          type="text"
                          size="small"
                        >
                          删除
                        </el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="12"> </el-col>
            </el-row>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="RoledefinitionQd('RoledefinitionRef')"
            >保 存</el-button
          >
          <el-button @click="definitionVisible = false">取 消</el-button>
        </div>
      </el-dialog>
      <!-- 选择角色弹窗 -->
      <div class="sales">
        <el-dialog
          width="30%"
          title="用户管理-用户角色定义-选择角色"
          :visible.sync="innerVisible"
        >
          <el-table
            height="300px"
            size="small"
            class="table-style"
            border
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              background: '#FCFBF2',
              color: '#6C6839',
              'text-align': 'center',
            }"
            :cell-style="{ 'text-align': 'center' }"
            ref="multipleTable1"
            :data="SelectroleList"
            tooltip-effect="dark"
            @selection-change="SelectroleListxd"
          >
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column type="selection" width="50"> </el-table-column>
            <el-table-column prop="roleCode" label="角色编号"> </el-table-column>
            <el-table-column prop="roleName" label="角色描述">
            </el-table-column>
          </el-table>

          <div slot="footer" class="dialog-footer">
            <el-button @click="SelectroleQd">确 定</el-button>
            <el-button @click="innerVisible = false">取 消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 首页查询卡 -->
    <el-card shadow="never">
      <div class="searchform">
        <el-form
          :label-position="labelPosition"
          label-width="100px"
          :model="queryInfoyh"
          size="small"
        >
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户编号">
                <el-input
                  style="width: 50%"
                  v-model="queryInfoyh.empCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :inline="true" label="用户姓名">
                <el-input
                  style="width: 50%"
                  v-model="queryInfoyh.empName"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :inline="true" label="门店">
                <el-input
                  style="width: 50%"
                  v-model="queryInfoyh.shopCode"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="员工类型">
                <el-select style="width: 50%" v-model="queryInfoyh.empKind">
                  <el-option label="全部员工" value=""></el-option>
                  <el-option label="门店员工" value="1"></el-option>
                  <el-option label="区域员工" value="2"></el-option>
                  <el-option label="公司员工" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="创建日期从">
                <el-date-picker
                  style="width: 50%"
                  v-model="queryInfoyh.datePicker"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :picker-options="pickerOptions"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-select style="width: 50%" v-model="queryInfoyh.state">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="有效" value="0"></el-option>
                  <el-option label="无效" value="1"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <!-- 首页列表表格 -->
    <el-card shadow="never" class="centercard">
      <el-table
        :height="isMoreyh ? 'calc(100vh - 29.3rem)' : 'calc(100vh - 27rem)'"
        size="small"
        class="table-style"
        border
        :row-class-name="tableRowClassName"
        :header-cell-style="{
          background: '#FCFBF2',
          color: '#6C6839',
          'text-align': 'center',
          fontSize: '14px',
        }"
        :cell-style="{ 'text-align': 'center' }"
        ref="multipleTable"
        :data="tableDatayh"
        tooltip-effect="dark"
        v-el-table-infinite-scroll="loadyh"
        v-loading="loadingyh"
        infinite-scroll-disabled="onLoadingyh"
      >
        <!-- <el-table-column type="selection" width="45"> </el-table-column> -->
        <!-- radio -->
        <el-table-column width="40">
          <template slot-scope="scope">
            <el-radio
              :label="scope.$index"
              v-model="syradio"
              @change="adminRadioChange(scope.row)"
              >&nbsp;</el-radio
            >
          </template>
        </el-table-column>
        <el-table-column prop="empCode" label="用户编号"> </el-table-column>
        <el-table-column prop="empName" label="姓名"> </el-table-column>
        <el-table-column prop="shopCode" label="门店"> </el-table-column>
        <el-table-column prop="mobile" label="手机号"> </el-table-column>
        <el-table-column prop="empKind" label="员工类型">
          <template slot-scope="scope">
            {{
              scope.row.empKind === 1
                ? "门店员工"
                : scope.row.empKind === 2
                ? "区域员工"
                : scope.row.empKind === 3
                ? "公司员工"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="empPosition" label="岗位">
          <template slot-scope="scope">
            {{
              scope.row.empPosition === 1
                ? "店员"
                : scope.row.empPosition === 2
                ? "店长"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="weChatUserID" label="企业微信ID">
        </el-table-column>
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            {{
              scope.row.state === 0
                ? "有效"
                : scope.row.state === 1
                ? "无效"
                : ""
            }}
          </template>
        </el-table-column>
        <el-table-column prop="createUserName" label="创建人">
        </el-table-column>
        <el-table-column prop="createTime" label="创建日期">
          <template slot-scope="scope">
            {{ scope.row.createTime | dateFormat }}
          </template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="最后修改人">
        </el-table-column>
        <el-table-column prop="updateTime" label="最后修改日期">
          <template slot-scope="scope">
            <div v-if="scope.row.updateTime !== null">
              {{ scope.row.updateTime | dateFormat }}
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-alert
        v-if="isMoreyh"
        title="没有更多啦!"
        type="warning"
        center
        show-icon
        :closable="false"
      >
      </el-alert>
    </el-card>
    <!-- 删除弹窗 -->
    <div class="delete">
      <el-dialog
        width="20%"
        title="删除操作权限"
        :visible.sync="deleteFormVisible"
        :close-on-click-modal="false"
      >
        <div style="height: 50px; font-size: 14px; font-weight: 700">
          <p>
            <i
              class="iconfont icon-jingshi"
              style="font-size: 28px; color: #f39b21"
            ></i>
            是否真的要<span style="color: #ff0000">删除</span>操作权限?
          </p>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="deletesj">确 定</el-button>
          <el-button @click="deleteFormVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  SysemppageApi,
  SysempinsertApi,
  SysempupdateApi,
  SysempqueryApi,
  SysempenableApi,
  SysempdisableApi,
  SysempRoleinsertApi,
  SysempqueryRoleByEmpIDApi,
} from "@/api/user";
import { shopselectListApi, SysrolequeryRoleListApi } from "@/api/shop";
import { dateTimes } from "@/utils/auth";
export default {
  name: "centre",
  data() {
    return {
      jurisdiction: {
        search: false,
        create: false,
        modify: false,
        enable: false,
        look: false,
        userdefined: false,
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一年",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      // 启用禁用弹窗
      EnabledisableFormVisible: false,
      radioValueYhList: [], //首页选中的数据
      // radio的禁用控制
      disabled: false,
      // 首页列表radio
      syradio: "",
      // 首页列表请求参数
      queryInfoyh: {
        pageNo: 1,
        pageSize: 50,
        pages: 0,
        empCode: "", //用户编号
        empName: "", //用户姓名
        shopCode: "", //门店
        empKind: "", //员工类型
        state: "", //状态
        datePicker: "",
        createDateStart: "", //创建日期开始
        createDateEnd: "", //创建日期结束
      },
      loadingyh: false,
      // 创建弹窗列表
      createFormyh: {
        empCode: "", //员工编号
        empName: "", //员工姓名
        mobile: "", //手机
        weChatUserID: "", //企业微信ID
        orgID: "", //门店id
        orgCode: "",
        shopname: "", //门店名称
        empKind: "", //员工类型
        empPosition: "", //员工岗位
        shoperKind: "", //店长类型
      },
      // 修改弹窗列表
      modifyYhList: {
        empID: "", //员工ID
        empCode: "", //员工编号
        empName: "", //员工姓名
        mobile: "", //手机
        weChatUserID: "", //企业微信ID
        orgID: "", //门店id
        orgCode: "", //门店编号
        shopname: "", //门店名称
        empKind: "", //员工类型
        empPosition: "", //员工岗位
        shoperKind: "", //店长类型
      },
      // 查看弹窗列表
      lookFormLabelYh: {
        empID: "", //员工ID
        empCode: "", //员工编号
        empName: "", //员工姓名
        mobile: "", //手机
        weChatUserID: "", //企业微信ID
        shopCode: "", //门店编号
        shopName: "", //门店名称
        empKind: "", //员工类型
        empPosition: "", //员工岗位
        shoperKind: "", //店长类型
        createUserName: "", //创建人
        createTime: "", //创建时间
        updateUserName: "", //修改人
        updateTime: "", // 修改时间
      },
      // 查看弹窗列表请求参数
      lookFormLabelYhcs: {
        empID: "", //员工ID
      },
      shopList: [],
      Enabledisablecs: {
        empID: "",
        state: "",
      },
      // 用户角色定义弹窗列表
      Roledefinition: {
        empCode: "", //员工编号
        empName: "", //员工姓名
        weChatUserID: "", //企业微信ID
        shopCode: "", //门店编号
        shopName: "", //门店名称

        empID: "", // 员工id
        dataRoleId: "", // 数据权限id
        roleIds: [], // 角色权限id数组
      },
      Roledefinitioncs: {
        empID: "",
      },
      // 数据权限列表
      DataauthorityList: [],
      // 用户角色定义弹窗
      definitionVisible: false,
      deleteFormVisible: false,
      // 创建弹窗
      foundFormVisible: false,
      // 修改弹窗
      amendFormVisible: false,
      // 查看弹窗
      lookFormVisible: false,
      // 创建内部弹窗
      innerVisible: false,
      innerVisible2: false,
      labelPosition: "right",
      labelPosition2: "top",
      form: {
        name: "",
        region: "",
        date1: "",
        date2: "",
        delivery: false,
        type: [],
        resource: "",
        desc: "",
      },
      tableDatayh: [],
      // 选择角色弹窗列表
      SelectroleList: [],
      // 操作权限列表
      Operationauthority: [],
      czcheckbox: "",
      // 创建验证表单
      createyhrules: {
        empCode: [
          { required: true, message: "请输入员工编号", trigger: "blur" },
        ],
        empName: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
        ],
        orgCode: [
          { required: true, message: "请输入门店编号", trigger: "blur" },
        ],
        empKind: [
          { required: true, message: "请选择员工类型", trigger: "change" },
        ],
        empPosition: [
          { required: true, message: "请选择员工岗位", trigger: "change" },
        ],
        shoperKind: [
          { required: true, message: "请选择店长类型", trigger: "change" },
        ],
      },
      // 角色定义验证表单
      Rolederules: {
        dataRoleId: [
          { required: true, message: "请选择数据权限", trigger: "blur" },
        ],
      },
      qiyongjinyong: "",
      index: "",
      rows: [],
    };
  },
  created() {
    this.SysemppageList();
    let UserManagement = JSON.parse(localStorage.getItem("UserManagement"));
    for (let i = 0; i < UserManagement.length; i++) {
      if (UserManagement[i].menuName == "查询") {
        this.jurisdiction.search = true;
        continue;
      }
      if (UserManagement[i].menuName == "创建") {
        this.jurisdiction.create = true;
        continue;
      }
      if (UserManagement[i].menuName == "修改") {
        this.jurisdiction.modify = true;
        continue;
      }
      if (UserManagement[i].menuName == "启用/禁用") {
        this.jurisdiction.enable = true;
        continue;
      }
      if (UserManagement[i].menuName == "查看") {
        this.jurisdiction.look = true;
        continue;
      }
      if (UserManagement[i].menuName == "用户角色定义") {
        this.jurisdiction.userdefined = true;
        continue;
      }
    }
  },
  computed: {
    // 用户管理首页列表
    isMoreyh() {
      //当起始页数等于总页数时停止加载
      return this.queryInfoyh.pageNo >= this.queryInfoyh.pages;
    },
    onLoadingyh() {
      return this.loadingyh || this.isMoreyh;
    },
  },
  mounted() {
    // 创建弹窗门店模糊搜索
    shopselectListApi().then((res) => {
      if (res.message == "success") {
        res.data.forEach((item) => {
          this.shopList.push({
            // id:item.shopID,
            value: item.ShopCode,
            name: item.ShopName,
            id: item.ShopID,
          });
        });
      }
    });
  },
  methods: {
    createdempKind(e) {
      if (e != 1) {
        this.createFormyh.empPosition = "";
        this.createFormyh.shoperKind = "";
      }
    },
    createEmpPositionChanged(e) {
      this.createFormyh.shoperKind = e == 2 ? 1 : "";
    },
    updatedempKind(e) {
      if (e != 1) {
        this.modifyYhList.empPosition = "";
        this.modifyYhList.shoperKind = "";
      }
    },
    updateEmpPositionChanged(e) {
      this.modifyYhList.shoperKind = e == 2 ? 1 : "";
    },
    // 首页列表
    async SysemppageList() {
      if (
        this.queryInfoyh.datePicker &&
        this.queryInfoyh.datePicker.length > 0
      ) {
        this.queryInfoyh.createDateStart = dateTimes(
          this.queryInfoyh.datePicker[0]
        );
        this.queryInfoyh.createDateEnd = dateTimes(
          this.queryInfoyh.datePicker[1]
        );
      } else {
        this.queryInfoyh.createDateStart = "";
        this.queryInfoyh.createDateEnd = "";
      }
      let data = {
        pageNo: this.queryInfoyh.pageNo,
        pageSize: this.queryInfoyh.pageSize,
        pages: this.queryInfoyh.pages,
        empCode: this.queryInfoyh.empCode, //用户编号
        empName: this.queryInfoyh.empName, //用户姓名
        shopCode: this.queryInfoyh.shopCode, //门店
        empKind: this.queryInfoyh.empKind, //员工类型
        state: this.queryInfoyh.state, //状态
        createDateStart: this.queryInfoyh.createDateStart, //创建日期开始
        createDateEnd: this.queryInfoyh.createDateEnd, //创建日期结束
      };
      await SysemppageApi(data).then((res) => {
        if (this.queryInfoyh.pageNo == 1) this.tableDatayh = [];
        this.tableDatayh = this.tableDatayh.concat(res.data.list);
        this.queryInfoyh.pages = res.data.pages;
        this.loadingyh = false;
      });
    },
    loadyh() {
      //滑到底部时进行加载
      this.loadingyh = true;
      setTimeout(() => {
        this.queryInfoyh.pageNo += 1;
        this.SysemppageList();
      }, 1000);
    },
    // 首页查询按钮查询事件
    async searchYhSy() {
      this.queryInfoyh.pageNo = 1;
      if (
        this.queryInfoyh.datePicker &&
        this.queryInfoyh.datePicker.length > 0
      ) {
        this.queryInfoyh.createDateStart = dateTimes(
          this.queryInfoyh.datePicker[0]
        );
        this.queryInfoyh.createDateEnd = dateTimes(
          this.queryInfoyh.datePicker[1]
        );
      } else {
        this.queryInfoyh.createDateStart = "";
        this.queryInfoyh.createDateEnd = "";
      }
      this.queryInfoyh.pageSize = 50;
      let data = {
        pageNo: this.queryInfoyh.pageNo,
        pageSize: this.queryInfoyh.pageSize,
        pages: this.queryInfoyh.pages,
        empCode: this.queryInfoyh.empCode, //用户编号
        empName: this.queryInfoyh.empName, //用户姓名
        shopCode: this.queryInfoyh.shopCode, //门店
        empKind: this.queryInfoyh.empKind, //员工类型
        state: this.queryInfoyh.state, //状态
        createDateStart: this.queryInfoyh.createDateStart, //创建日期开始
        createDateEnd: this.queryInfoyh.createDateEnd, //创建日期结束
      };
      await SysemppageApi(data).then((res) => {
        if (res.success !== true) {
          this.$message.error("查询用户管理列表失败!");
          return;
        }
        this.$message.success("查询用户管理列表成功!");
        this.tableDatayh = res.data.list;
        this.queryInfoyh.pages = res.data.pages;
        this.syradio = "";
        this.radioValueYhList = "";
      });
    },
    // 点击创建弹窗事件
    createYhtc() {
      this.foundFormVisible = true;
    },
    querySearch(queryString, cb) {
      var shopList = this.shopList;
      var results = queryString
        ? shopList.filter(this.createFilter(queryString))
        : shopList;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (shoplis) => {
        return (
          shoplis.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    handleSelect(item) {
      // 创建弹窗数据传值
      this.createFormyh.shopname = item.name;
      this.createFormyh.orgID = item.id;
      // 修改弹窗数据传值
      this.modifyYhList.shopname = item.name;
      this.modifyYhList.orgID = item.id;
    },
    // // 创建弹窗根据选择禁用触发radio
    // gaibian() {
    //   if (this.createFormyh.empKind == "1") {
    //     this.disabled = false;
    //   } else {
    //     this.disabled = true;
    //     this.createFormyh.empPosition = "1";
    //   }
    // },
    // 监听创建对话框的关闭事件
    CreatedYhClosed() {
      this.$refs.createFormyhRef.resetFields();
    },
    // 用户管理创建
    createYh(createFormyhRef) {
      this.$refs[createFormyhRef].validate(async (valid) => {
        if (!valid) return;
        await SysempinsertApi(this.createFormyh).then((res) => {
          if (res.success !== true) {
            this.$message.error("创建用户失败");
            return;
          }
          this.$message.success("创建用户成功");
          // 隐藏创建用户对话框
          this.foundFormVisible = false;
          // 重新获取用户管理列表
          this.SysemppageList();
          this.syradio = "";
          this.radioValueYhList = "";
        });
      });
    },
    // 用户管理修改按钮事件
    modifyYhtc() {
      if (this.radioValueYhList.length == 0) {
        this.$message.warning("请选择单条数据,进行修改");
      } else {
        this.modifyYhlb();
        this.amendFormVisible = true;
      }
    },
    // 点击修改按钮将单据号传给修改弹窗列表
    modifyYhlb() {
      this.modifyYhList.empID = this.radioValueYhList.empID; //员工id
      this.modifyYhList.empCode = this.radioValueYhList.empCode; //员工编号
      this.modifyYhList.empName = this.radioValueYhList.empName; //员工姓名
      this.modifyYhList.mobile = this.radioValueYhList.mobile; //手机
      this.modifyYhList.weChatUserID = this.radioValueYhList.weChatUserID; //企业微信ID
      this.modifyYhList.orgID = this.radioValueYhList.orgID; //门店ID
      this.modifyYhList.orgCode = this.radioValueYhList.shopCode; //门店编号
      this.modifyYhList.shopname = this.radioValueYhList.shopName; //门店名称
      this.modifyYhList.empKind = this.radioValueYhList.empKind; //员工类型
      this.modifyYhList.empPosition = this.radioValueYhList.empPosition; //员工岗位
      if (
        [0, 1, "0", "1"].includes(this.radioValueYhList.shoperKind) &&
        this.radioValueYhList.empPosition == 2
      ) {
        this.modifyYhList.shoperKind = this.radioValueYhList.shoperKind; //店长类型
      } else {
        this.modifyYhList.shoperKind = "";
      }
    },
    // 修改用户管理确定事件
    async ModifyQdqq() {
      this.$refs["modifyFormRef"].validate(async (valid) => {
        if (!valid) return;
        await SysempupdateApi(this.modifyYhList).then((res) => {
          if (res.success !== true) {
            this.$message.error("修改用户管理失败");
            return;
          }
          this.$message.success("修改用户管理成功");
          // 隐藏修改弹窗
          this.amendFormVisible = false;
          // 重新获取用户管理列表
          this.SysemppageList();
          this.syradio = "";
          this.radioValueYhList = "";
        });
      });
    },
    // 修改弹窗根据选择禁用触发radio
    // Xggaibian() {
    //   if (this.modifyYhList.empKind == "1") {
    //     this.disabled = false;
    //   } else {
    //     this.disabled = true;
    //     this.modifyYhList.empPosition = 1;
    //   }
    // },
    // 监听修改弹框的关闭事件
    ModifyYhClosed() {
      this.$refs.modifyFormRef.resetFields();
    },
    // 用户管理 -- 查看
    LookYhlb() {
      if (this.radioValueYhList.length == 0) {
        this.$message.warning("请选择单条数据,进行查看");
      } else {
        // 获取empID
        this.lookYhqq();
        // 发送请求查看记录
        SysempqueryApi(this.lookFormLabelYhcs).then((res) => {
          this.lookFormLabelYh = res.data;

          if (res.success !== true) {
            this.$message.error("查看用户管理列表失败");
            return;
          }
          this.$message.success("查看用户管理列表成功");
        });
        this.lookFormVisible = true;
      }
    },
    // 监听查看弹框的关闭事件
    SeeYhlbClose() {
      this.$refs.lookFormRef.resetFields();
    },
    // 获取empID
    lookYhqq() {
      this.lookFormLabelYhcs.empID = this.radioValueYhList.empID;
    },
    // 启用禁用按钮请求
    Enabledisable() {
      if (this.Enabledisablecs.empID.length == 0) {
        this.$message.warning("请选择用户,进行启用/禁用");
        return;
      } else {
        if (this.Enabledisablecs.state === 0) {
          this.qiyongjinyong = "禁用";
        } else {
          this.qiyongjinyong = "启用";
        }
        this.EnabledisableFormVisible = true;
      }
    },
    // 启用禁用提示框确定事件
    Enabledisableqd() {
      if (this.Enabledisablecs.state === 0) {
        this.SysempdisableApi();
      } else {
        this.SysempenableApi();
      }
    },
    // 用户启用接口
    async SysempenableApi() {
      await SysempenableApi(this.Enabledisablecs).then((res) => {
        if (res.success !== true) {
          this.$message.error("启用用户失败");
          return;
        }
        this.$message.success("启用用户成功");
        // 重新获取用户管理列表
        this.SysemppageList();
        this.syradio = "";
        this.radioValueYhList = "";
        this.Enabledisablecs.empID = "";
        // 隐藏提示框
        this.EnabledisableFormVisible = false;
      });
    },
    // 用户禁用接口
    async SysempdisableApi() {
      await SysempdisableApi(this.Enabledisablecs).then((res) => {
        if (res.success !== true) {
          this.$message.error("禁用用户失败");
          return;
        }
        this.$message.success("禁用用户成功");
        // 重新获取用户管理列表
        this.SysemppageList();
        this.syradio = "";
        this.radioValueYhList = "";
        this.Enabledisablecs.empID = "";
        // 隐藏提示框
        this.EnabledisableFormVisible = false;
      });
    },
    // 点击radio获取首页列表行数据
    adminRadioChange(value) {
      this.radioValueYhList = value;
      console.log(JSON.parse(JSON.stringify(value)));
      // 启用禁用请求参数id
      this.Enabledisablecs.empID = this.radioValueYhList.empID;
      this.Enabledisablecs.state = this.radioValueYhList.state;
    },
    // 用户角色定义数据弹窗事件
    roledefinition() {
      if (this.radioValueYhList.length == 0) {
        this.$message.warning("请选择单条数据,进行用户角色定义");
      } else {
        this.definitionVisible = true;
        // 获取ID
        this.HuoquID();
        // 获取列表请求
        this.roledefinitionlb();
        this.sroSylequeryRoleList();
      }
    },
    roledefinitionlb() {
      SysempqueryRoleByEmpIDApi(this.Roledefinitioncs).then((res) => {
        this.Roledefinition = res.data;
        // this.Roledefinition.dataRoleId = res.data.dataRole.roleID
        if (res.data.dataRole != null) {
          this.$set(
            this.Roledefinition,
            "dataRoleId",
            res.data.dataRole.roleID
          );
        }
        res.data.operRoles.forEach((item) => {
          this.Operationauthority.push(item);
        });
      });
      // this.Roledefinition.empID = this.radioValueYhList.empID;
      // this.Roledefinition.empCode = this.radioValueYhList.empCode;
      // this.Roledefinition.empName = this.radioValueYhList.empName;
      // this.Roledefinition.weChatUserID = this.radioValueYhList.weChatUserID;
      // this.Roledefinition.shopCode = this.radioValueYhList.shopCode;
      // this.Roledefinition.shopName = this.radioValueYhList.shopName;
    },
    // 获取empID
    HuoquID() {
      this.Roledefinitioncs.empID = this.radioValueYhList.empID;
    },
    // 用户角色定义 --- 数据权限
    sroSylequeryRoleList() {
      SysrolequeryRoleListApi({ roleType: "1" }).then((res) => {
        this.DataauthorityList = res.data;
      });
    },
    // 用户角色定义 --- 选择角色事件
    Selectrole() {
      this.innerVisible = true;
      this.sroSylequeryRoleForm();
    },
    // 选择角色列表
    sroSylequeryRoleForm() {
      SysrolequeryRoleListApi({ roleType: "0" }).then((res) => {
        this.SelectroleList = res.data;
        if (this.SelectroleList.length > 0) {
          let checkedData = this.Operationauthority;
          this.$nextTick(() => {
            if (checkedData.length > 0) {
              checkedData.forEach((row) => {
                this.$refs.multipleTable1.toggleRowSelection(
                  this.SelectroleList.find((item) => {
                    return row.roleID == item.roleID;
                  }),
                  true
                );
                // this.$refs.multipleTable1.toggleRowSelection(item);
              });
            }
          });
        }
      });
    },
    // 选择角色列表确定事件
    SelectroleQd() {
      this.Operationauthority = [];
      for (var i = 0; i < this.czcheckbox.length; i++) {
        this.Operationauthority.push(this.czcheckbox[i]);
      }
      this.innerVisible = false;
    },
    // 选择角色列表选中获取数据
    SelectroleListxd(value) {
      this.czcheckbox = value;
    },
    // 用户角色定义确定事件
    RoledefinitionQd(RoledefinitionRef) {
      this.Roledefinition.roleIds = [];
      for (var i = 0; i < this.Operationauthority.length; i++) {
        this.Roledefinition.roleIds.push(this.Operationauthority[i].roleID);
      }
      this.$refs[RoledefinitionRef].validate(async (valid) => {
        if (!valid) return;
        // 关闭弹窗
        this.definitionVisible = false;
        // 调用角色定义接口
        this.SysempRoleinsertApi();
      });
    },
    // 用户角色定义确定事件请求
    async SysempRoleinsertApi() {
      let SysempRoleinsertcs = {
        empID: this.Roledefinition.empID,
        dataRoleId: this.Roledefinition.dataRoleId,
        roleIds: this.Roledefinition.roleIds.join(","),
      };
      await SysempRoleinsertApi(SysempRoleinsertcs).then((res) => {
        if (res.success !== true) {
          this.$message.error("角色定义失败！");
          return;
        }
        {
          this.$message.success("角色定义成功！");
          this.syradio = "";
          this.radioValueYhList = "";
        }
      });
    },
    // 监听用户角色定义弹窗关闭事件
    RoledefinitionClose() {
      this.$refs.RoledefinitionRef.resetFields();
      this.Operationauthority = [];
    },
    // 用户角色定义弹窗表格删除操作
    deleteRow(index, rows) {
      this.deleteFormVisible = true;
      this.index = index;
      this.rows = rows;
      // rows.splice(index, 1);
    },
    deletesj() {
      this.rows.splice(this.index, 1);
      this.deleteFormVisible = false;
    },
    // 判断如果是单行就变黄色双行是白色
    tableRowClassName({ rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "warning-row";
      }
      return "";
    },
  },
};
</script>
<style lang="scss" scoped>
// #alterations {
//   height: 100%;
// }
.header-text {
  height: 50px;
  margin-top: 20px;
  color: #76734f;
}
.searchform {
  margin-top: 20px;
}
.centercard {
  margin-top: 10px;
}
.card-pagination {
  margin-top: 20px;
  text-align: right;
}
// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
.shanchuanniu {
  border-color: transparent;
}
/deep/input {
  border-radius: 0 !important;
}
// 去除表头复选框
/deep/.table-style {
  .el-table-column--selection.is-leaf .el-checkbox {
    display: none;
  }
}

.el-table .warning-row {
  background: #fcfbf2;
}

.el-table .success-row {
  background: #ffffff;
}
::v-deep {
  .el-table .warning-row {
    background: #fcfbf2;
  }

  .el-table .success-row {
    background: #ffffff;
  }
  // 改变table里的按钮图标大小
  .table-button .iconfont {
    font-size: 14px;
  }
  // 改变分页背景色
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #d1cda5 !important;
    color: #ffffff !important;
  }
  // 改变分页字体颜色
  .el-pagination.is-background .btn-next,
  .el-pagination.is-background .btn-prev,
  .el-pagination.is-background .el-pager li {
    color: #d1cda5 !important;
  }

  // 设置表单里字体的颜色
  .el-form-item__label {
    color: #76734f;
  }
  // 修改弹窗样式
  .amend {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 创建弹窗样式
  .found {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 删除弹框样式
  .delete {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 查看弹窗样式
  .look {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  .definition {
    .el-dialog__header {
      background-color: #f3f1dd;
    }
    .el-dialog__title {
      font-size: 14px;
      font-weight: 700;
      color: #6c6937;
    }

    .el-dialog__footer {
      height: 60px;
      background-color: #f2f2f2;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
  // 启用禁用弹框样式
  .Enabledisable {
    .el-dialog__header,
    .el-message-box__header {
      border-top-left-radius: 9px;
      border-top-right-radius: 9px;
      height: 44px;
      background: #f3f1dd;
      width: 100%;
      text-align: center;
      color: #666;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 20px;
      box-sizing: border-box;
    }
    .el-dialog__title,
    .el-message-box__title {
      color: #6c6937;
      font-weight: 700;
      font-size: 16px !important;
    }
    .el-dialog .el-dialog__body {
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .coverage-release .el-dialog__body {
      padding: 20px;
    }
    .el-button:hover {
      background-color: #b6b388;
    }
    .el-dialog__body {
      padding: 30px 60px;
    }
    .el-tabs__item {
      border: 1px solid #d9d9d9;
      background-color: #fff;
      color: #6c6937;
    }
    .el-dialog__footer {
      height: 60px;
      text-align: center;
      background-color: #f2f2f2;
    }

    .el-tabs__item.is-active {
      color: #6c6937;
      background-color: #f3f1dd;
    }
    .el-form-item__content {
      line-height: 0px;
    }
    .el-textarea__inner {
      // 取消拉伸样式
      resize: none;
    }
  }
}
</style>
